import { DialogObject } from '../../../../components/dialog/dialog.types';
import { TranslateService } from '@ngx-translate/core';
import { EmailContentViewerComponent } from '../components/email-content-viewer.component';

interface getEmailTraceInspectDialogObjectProps {
  t: TranslateService;
  representation?: string;
  emailContent?: string;
  toggleVisiblity?: () => void;
}

export const getEmailTraceInspectDialogObject = ({
  t,
  representation,
  emailContent,
  toggleVisiblity,
}: getEmailTraceInspectDialogObjectProps): DialogObject => {
  return {
    title: t.instant('settings.emailTrace.inspect.title'),
    description: t.instant('settings.emailTrace.inspect.description', { email: representation }),
    width: '800px',
    component: {
      outlet: EmailContentViewerComponent,
      props: {
        content: emailContent || '',
      },
    },
    actions: [
      {
        label: t.instant('common.dialog.cancel'),
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick: toggleVisiblity || (() => {}),
        variant: 'secondary',
      },
    ],
  };
};
